export default __webpack_public_path__ + "static/media/fb.b7efcc81.jpg";